import { getDaysFromCurrentDate } from '../../../../services/datetime-service';

export const ThirtyDays = 30;

/**
 * Returns whether the supplied ISO string value is between 0 and 30 days from now.
 * @param {string} expireDateTimeISO
 * @returns {boolean}
 */
export const getIsApiKeyExpiringSoon = (expireDateTimeISO) => {
  const daysUntilExpiration = getDaysFromCurrentDate(expireDateTimeISO);
  const isExpired = daysUntilExpiration < 0;
  const willExpireSoon = !isExpired && Number(daysUntilExpiration) <= ThirtyDays;
  return willExpireSoon;
};

/**
 * @param {import('../types/api-keys').APIKeysV1[]} apiKeys
 * @returns {boolean}
 */
export const hasExpiringApiKeys = (apiKeys) => {
  return apiKeys?.some((apiKey) => getIsApiKeyExpiringSoon(apiKey.expireDateTime));
};
